import {SETEAR_USUARIO, ELIMINAR_USUARIO, SETEAR_LOADING, ERROR_CARGA_USUARIO} from 'types';

import {localVar} from 'components/constants';

const initialState = {
    usuario: {},
    token: null,
    error: null,
    loading: false,
};

export default function (state = initialState, action) {
    switch (action.type) {
        case SETEAR_LOADING:
            return {
                ...state,
                loading: action.payload,
                error: null
            };
        case ERROR_CARGA_USUARIO:
            return {
                ...state,
                error: action.payload,
                loading: false
            }
        case SETEAR_USUARIO:
            localVar.setItem('token', action.payload.token);
            return {
                ...state,
                usuario: action.payload.usuario,
                token: action.payload.token,
                loading: false,
                error: null
            };
        case ELIMINAR_USUARIO:
            return initialState
        default:
            return state;
    }
}
